/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandJuejin = createReactComponent("brand-juejin", "IconBrandJuejin", [
  ["path", { d: "M2 12l10 7.422l10 -7.422", key: "svg-0" }],
  ["path", { d: "M7 9l5 4l5 -4", key: "svg-1" }],
  ["path", { d: "M11 6l1 .8l1 -.8l-1 -.8z", key: "svg-2" }]
]);

export { IconBrandJuejin as default };
//# sourceMappingURL=IconBrandJuejin.js.map
